import { designVariables as tk } from "@studio3t/design-variables";
import styled from "styled-components";

// The chip bar's frame, shared by the "attach" and "follows-view" bars;
// the chips themselves are AttachmentChip.

/** Truncate script name for display */
export function truncateName(name: string, maxLen = 14): string {
  if (name.length <= maxLen) return name;
  return `${name.slice(0, maxLen - 1)}…`;
}

export const AttachmentBar = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: ${tk.ui.semantic.spacingm}px ${tk.ui.semantic.spacingm}px
    ${tk.ui.semantic.spacings}px;
  border-top: 1px solid ${(p) => p.theme.cards1Border};
  flex-shrink: 0;
  flex-wrap: wrap;
`;

export const AttachmentLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: ${(p) => p.theme.semanticTextBody};
  margin-right: 2px;
`;
